export function sendToGoogleTagManager(...args: any[]): void {
  if (process.env['NODE_ENV'] !== 'production') {
    return;
  }

  const dataLayer = window.dataLayer || [];

  dataLayer.push(...args);
}
